import { useState } from 'react';
import { ChevronDown, ChevronRight, FileText } from 'lucide-react';

const fmt = (a) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(a || 0);

export function StatementsArchive({ statements, onArchive, currentMonth }) {
  const years = Object.keys(statements || {}).sort((a, b) => b - a);

  return (
    <div className="bg-white rounded-xl border-2 border-gray-200 p-6">
      <div className="text-center mb-4">
        <div className="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-3">
          <FileText className="w-7 h-7 text-gray-600" />
        </div>
        <h3 className="text-lg font-bold text-[#0A1628]">Monthly Statements</h3>
        <p className="text-xs text-gray-500">Partner profit archives</p>
      </div>

      <button onClick={onArchive} className="w-full mb-4 py-2.5 bg-[#014DB7] text-white text-sm font-semibold rounded-lg hover:bg-[#003A8C] transition-colors">
        Archive {currentMonth}
      </button>

      {years.length === 0 ? (
        <p className="text-sm text-gray-400 text-center py-4">No archived statements yet</p>
      ) : (
        <div className="space-y-2">
          {years.map(yr => <YearAccordion key={yr} year={yr} months={statements[yr]} />)}
        </div>
      )}
    </div>
  );
}

function YearAccordion({ year, months }) {
  const [open, setOpen] = useState(true);
  return (
    <div className="border rounded-lg overflow-hidden">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors">
        <span className="font-bold text-[#0A1628]">{year}</span>
        {open ? <ChevronDown className="w-4 h-4 text-gray-400" /> : <ChevronRight className="w-4 h-4 text-gray-400" />}
      </button>
      {open && (
        <div className="divide-y">
          {(months || []).map(m => <MonthRow key={m.month} statement={m} />)}
        </div>
      )}
    </div>
  );
}

function MonthRow({ statement }) {
  const isPositive = statement.net_profit >= 0;
  return (
    <div className="px-4 py-2.5 flex items-center justify-between text-sm hover:bg-gray-50">
      <span className="font-medium text-gray-700">{statement.month_name}</span>
      <div className="text-right">
        <p className={`font-bold ${isPositive ? 'text-green-600' : 'text-red-500'}`}>{fmt(statement.net_profit)}</p>
        <p className="text-[10px] text-gray-400">each: {fmt(statement.danny_share)}</p>
      </div>
    </div>
  );
}
